/**
 * Toolbar buttons
 */
const basicFormat = 'bold italic underline';
const format = 'strikethrough | undo redo restoredraft';
const removeFormat = 'removeformat';
const links = 'link unlink';
const list = 'bullist numlist';
const align = 'outdent indent | alignleft aligncenter alignright';
const stylesDropdown = 'styles';

const base = `${stylesDropdown} | ${basicFormat} ${format} ${removeFormat}| ${links} | code`;
const article = `${stylesDropdown} | blockquoteButton | infoboxButton | ${basicFormat} ${format} ${removeFormat}| ${links} | code | placeHolderButton | parallaxButton | paywallButton | ${list} | ${align} | media`;
const banner = `styles ${basicFormat} | ${removeFormat} | ${list} | code`;
const marketing = `${basicFormat} strikethrough | ${removeFormat} | forecolor`;

export const toolbar = {
  base,
  article,
  banner,
  marketing,
};

/**
 * Styles format dropdown
 */
export const styles = [
  { attributes: { class: '' }, block: 'p', title: 'Absatz' },
  { block: 'h2', title: 'Zwischenüberschrift' },
  {
    attributes: { class: 'interview-question' },
    block: 'p',
    title: 'Interview Frage',
  },
  {
    attributes: { class: 'interview-answer' },
    block: 'p',
    title: 'Interview Antwort',
  },
];

/**
 * Base Plugins
 */
export const plugins = {
  default: 'autolink autosave link wordcount',
  banner: 'autoresize code lists',
};
